import { FACE_SWAP_AND_MODEL_PAYLOAD } from "@/utils/toolsConstants";
import {create} from "zustand";

const useBatchStore = create((set) => ({
  promptData: null,
  projectList: [],
  projectListLoading:false,
  totalJobCount: 0,
  generatingMore:false,
  selectedSeedData:{
    initialSeed:"",
    needSimilar:false,
  },
  promptDropdownObject:{},
  selectedImage:null,
  updateSelectedImageforPrompt:false,
  selectedImageForPrompt: null,
  fetchingPromptImageList: [],
  imageFileFormat: {
    width:1500,
    height:1500
  },
  promptImageLoading: false,
  cancelImagePolling: false,
  selectedEditorImagePreview: null,
  previewSliderImageList:[],
  previewSliderSelectedImage:null,
  selectedProjectData:null,
  imageAdjustment:false,
  refreshJobList:false,
  upscaleKeyActive:false,
  promptObject:{},
  imageAdjustObject:{
    coverage:0,
    position:"center center"
  },
  referenceImagePreview:false,
  selectedProjectForGeneration:{},
  selectedProjectGenerationImage:{},
  batchAIGenUpdated:[],
  inpaintImageUrl:"",
  inpaintSelectedImageForPrompt:{},
  isModified:false,
  isInpaintApplying:false,
  resetInpaint:false,
  batchAIType:"",
  selectedImagePreview:null,
  faceSwapAndModelPayload:FACE_SWAP_AND_MODEL_PAYLOAD,
  showReference:true,
  loadingCanvas:true,
  applyingData:false,
  resetAllSetting:false,
  eraseAndRebuildCanvas:false,
  batchId: "",
  inpaintApplying:false,
  setBatchId: (batchId) =>set({batchId}),
  batchLabel: "",
  startInpaintTutorial:null,
  externalImageLoading:false,
  jobOrderLabel: "",
  totalBackgroundCount: null,
  setPromptData: (newPromptData) => 
    set({ promptData: newPromptData }),
  setProjectList: (newProjectList) => 
    set({ projectList: newProjectList }),
  setSelectedImage: (newSelectedImage) => 
    set({ selectedImage: newSelectedImage }),
  setSelectedImageForPrompt: (newSelectedImage) =>
    set({ selectedImageForPrompt: newSelectedImage }),
  setFetchingPromptImageList: (newFetchingPromptImageList) =>
    set({ fetchingPromptImageList: newFetchingPromptImageList }),
  setPromptImageLoading: (newPromptImageLoading) =>
    set({ promptImageLoading: newPromptImageLoading }),
  setTotalJobCount: (newTotalJobCount) =>
    set({ totalJobCount: newTotalJobCount}),
  setCancelImagePolling: (newCancelImagePolling) =>
    set({ cancelImagePolling: newCancelImagePolling }),
  setSelectedEditorImagePreview: (newSelectedEditorImagePreview) =>
    set({ selectedEditorImagePreview: newSelectedEditorImagePreview }),
  setPreviewSliderImageList: (newPreviewSliderImageList) =>
    set({previewSliderImageList:newPreviewSliderImageList}),
  setPreviewSliderSelectedImage:(newPreviewSliderSelectedImage) =>
    set({previewSliderSelectedImage:newPreviewSliderSelectedImage}),
  setSelectedProjectData: (newSelectedProjectData) =>
    set({ selectedProjectData: newSelectedProjectData }),
  setImageAdjustment: (newImageAdjustment) =>
    set({ imageAdjustment: newImageAdjustment }),
  setSelectedSeedData: (newSelectedSeedData) =>
    set({selectedSeedData: newSelectedSeedData}),
  setPromptDropdownObject: (newPromptDropdownObject) =>
    set({promptDropdownObject: newPromptDropdownObject}),
  setUpdateSelectedImageforPrompt: (newUpdateSelectedImageforPrompt) =>
    set({updateSelectedImageforPrompt: newUpdateSelectedImageforPrompt}),
  setRefreshJobList: (newRefreshJobList) => 
    set({refreshJobList: newRefreshJobList}),
  setUpscaleKeyActive: (newUpscaleKeyActive) =>
    set({upscaleKeyActive: newUpscaleKeyActive}),
  setImageFileFormat: (newImageFileFormat) =>
    set({imageFileFormat:newImageFileFormat}),
  setPromptObject: (newPromptObject) =>
    set({promptObject: newPromptObject}),
  setImageAdjustObject: (newImageAdjustObject) =>
    set({imageAdjustObject: newImageAdjustObject}),
  setReferenceImagePreview: (newReferenceImagePreview) =>
    set({referenceImagePreview: newReferenceImagePreview}),
  setProjectListLoading: (newProjectListLoading) =>
    set({projectListLoading: newProjectListLoading}),
  setGeneratingMore: (newGeneratingMore) =>
    set({generatingMore: newGeneratingMore}),
  setSelectedProjectForGeneration: (newSelectedProjectForGeneration) =>
    set({selectedProjectForGeneration: newSelectedProjectForGeneration}),
  setSelectedProjectGenerationImage: (newSelectedProjectGenerationImage) =>
    set({selectedProjectGenerationImage: newSelectedProjectGenerationImage}),
  setBatchAIGenUpdated:(newBatchAIGenUpdated)=>
    set({batchAIGenUpdated:newBatchAIGenUpdated}),
  setInpaintImageUrl: (newInpaintImageUrl) => 
    set({inpaintImageUrl: newInpaintImageUrl}),
  setInpaintSelectedImageForPrompt:(newInpaintSelectedImageForPrompt)=>
    set({inpaintSelectedImageForPrompt:newInpaintSelectedImageForPrompt}),
  setIsModified: (newIsModified) => 
    set({isModified:newIsModified}),
  setIsInpaintApplying: (newIsInpaintApplying) =>
    set({isInpaintApplying:newIsInpaintApplying}),
  setResetInpaint: (newResetInpaint) =>
    set({resetInpaint:newResetInpaint}),
  setBatchAIType: (newBatchAIType) =>
    set({batchAIType:newBatchAIType}),
  setSelectedImagePreview: (newSelectedImagePreview)=>
    set({selectedImagePreview:newSelectedImagePreview}),
  setFaceSwapAndModelPayload: (newFaceSwapPayload)=>
    set({faceSwapAndModelPayload:newFaceSwapPayload}),
  setShowReference: (newShowReference) =>
    set({showReference:newShowReference}),
  setLoadingCanvas:(newLoadingCanvas) =>
    set({loadingCanvas:newLoadingCanvas}),
  setApplyingData:(newApplyingData)=>
    set({applyingData:newApplyingData}),
  setResetAllSetting:(newResetAllSetting)=>
    set({resetAllSetting:newResetAllSetting}),
  setEraseAndRebuildCanvas:(newEraseAndRebuildCanvas)=>
    set({eraseAndRebuildCanvas:newEraseAndRebuildCanvas}),
  setBatchLabel:(newBatchLabel)=>
    set({batchLabel:newBatchLabel}),
  setInpaintApplying:(newInpaintApplying)=>
    set({inpaintApplying:newInpaintApplying}),
  setStartInpaintTutorial:(newStartInpaintTutorial)=>
    set({startInpaintTutorial:newStartInpaintTutorial}),
  setExternalImageLoading:(newExternalImageLoading)=>
    set({externalImageLoading:newExternalImageLoading}),
  setJobOrderLabel:(newJobOrderLabel)=>
    set({jobOrderLabel:newJobOrderLabel}),
  setTotalBackgroundCount: (newTotalBackgroundCount) =>
    set({totalBackgroundCount: newTotalBackgroundCount}),
  resetBulkUploadStore: () => 
    set({
      promptData: null,
      projectList: [],
      projectListLoading:false,
      totalJobCount: 0,
      generatingMore:false,
      selectedSeedData:{
        initialSeed:"",
        needSimilar:false
      },
      updateSelectedImageforPrompt:false,
      selectedImageForPrompt: null,
      selectedImage:null,
      fetchingPromptImageList: [],
      imageFileFormat: {
        width:1500,
        height:1500
      },
      promptImageLoading: false,
      cancelImagePolling: false,
      selectedEditorImagePreview: null,
      previewSliderImageList:[],
      previewSliderSelectedImage:null,
      selectedProjectData:null,
      imageAdjustment:false,
      refreshJobList:false,
      upscaleKeyActive:false,
      promptObject:{},
      imageAdjustObject:{
        coverage:0,
        position:"center center"
      },
      referenceImagePreview:false,
      selectedProjectForGeneration:{},
      selectedProjectGenerationImage:{},
      batchAIGenUpdated:[],
      inpaintImageUrl:"",
      inpaintSelectedImageForPrompt:{},
      isModified:false,
      batchAIType:"",
      selectedImagePreview:null,
      faceSwapAndModelPayload:FACE_SWAP_AND_MODEL_PAYLOAD,
      showReference:true,
      loadingCanvas:true,
      applyingData:false,
      resetAllSetting:false,
      batchLabel: "",
      inpaintApplying:false,
      startInpaintTutorial:null,
      externalImageLoading:false,
      jobOrderLabel: "",
      totalBackgroundCount: null,
    }),
    resetInpaint: () => 
      set({
        selectedProjectForGeneration:{},
        selectedProjectGenerationImage:{},
        batchAIGenUpdated:[],
        inpaintImageUrl:"",
        inpaintSelectedImageForPrompt:{},
        isModified:false,
        isInpaintApplying:false,
        selectedImagePreview:null,
        selectedImage:null,
        startInpaintTutorial:null,
        externalImageLoading:false,
      }),
}));

export default useBatchStore;
